import {cookieDisclaimerBottomPosition} from "../modules/CookieDisclaimer";

if (App.H.is('.page-constructor')) {
    if (window.disclaimerContent) {
        $('.c-footer__nav .wrap').append(window.disclaimerContent);
    }

    $('.js-footer-disclaimer-close').each((i, el) => {
        let $footerDisclaimerClose = $(el);

        // сначала использовали sessionStorage, удаляем его
        if (sessionStorage.getItem('footerDisclaimerClose')) {
            sessionStorage.removeItem('footerDisclaimerClose');
        } else {
            $footerDisclaimerClose.on('click', function () {
                // если нет атрибута data-not-cache (без кеша), тогда записываем факт того что пользователь закрыл баннер и больше ему его не будем показывать
                // если есть атрибут, то просто закрываем дисклеймер
                if (!$footerDisclaimerClose.is('[data-not-cache]')) {
                    $.cookie('footerWarningClose', '1', {expires: 365, path: '/' });
                }

                $footerDisclaimerClose.parent().empty();
            });
        }
    });

    $('.js-footer-warning-label').each((i, el) => {
        let $footerWarning = $(el);
        let $footerWarningClose = $('.js-footer-warning-label-close', $footerWarning);
        let $bottom = $('.c-footer__bottom');

        $('.c-footer__nav-content').css('padding-bottom', $(el).innerHeight() + 'px');

        App.W.on('resize', function() {
            $('.c-footer__nav-content').css('padding-bottom', $(el).innerHeight() + 'px');
        });
        
        if ($.cookie) {
            if ($.cookie('footerWarningClose')) {
                $footerWarning.addClass('_closed');
                $footerWarning.css('bottom', $bottom.outerHeight() + 'px');
                cookieDisclaimerBottomPosition();
            }
        }

        if (sessionStorage.getItem('footerWarningClose')) {
            sessionStorage.removeItem('footerDisclaimerClose');
        } else {
            $footerWarningClose.on('click', function () {
                if($('#disclaimer-container').find('.c-footer__warning-label').length === 0){
                    $('#disclaimer-container').append($('.c-footer__warning-label'))
                }
                if (!$footerWarningClose.is('[data-not-cache]')) {
                    $.cookie('footerWarningClose', '1', {expires: 365, path: '/' });
                }

                $footerWarning.addClass('_closed');
                $footerWarning.css('bottom', $bottom.outerHeight() + 'px');

                cookieDisclaimerBottomPosition();
            });
        }

        App.W.on('scroll resized', function() {
            fixedWarning();
        });

        function fixedWarning() {
            if (window.innerHeight + window.pageYOffset >= $bottom.offset().top || $bottom.hasClass('_closed')) {
                $footerWarning.addClass('_abs');
                $footerWarning.css('bottom', $bottom.outerHeight() + 'px');
            } else {
                $footerWarning.removeClass('_abs');
                $footerWarning.css('bottom', '');
            }
        }
    });

    $('.js-under-footer-hide').each((i, el) => {
        let $footer = $('.c-footer');
        let $hiddenEl = $(el);

        App.W.on('scroll resized', hideElement);

        function hideElement() {
            if ($hiddenEl.offset().top >= $footer.offset().top) {
                $hiddenEl.addClass('_hidden');
            } else {
                $hiddenEl.removeClass('_hidden');
            }
        }
    });
}
